export function listenToPTSJobs(jobs) {
  return {
    type: "LISTEN_TO_PTS_JOBS",
    payload: jobs,
  };
}
